import axios, { type AxiosInstance } from "axios"
import config from "config"
import type { IChapter, ICreateChapter, IUpdateChapter } from "types/chapterTypes"

import authService from "./authService"

class ChapterService {
  private http: AxiosInstance

  public constructor() {
    this.http = axios.create({
      baseURL: config.apiUrl,
      headers: {
        "Content-type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
    })
  }

  public createChapter = async (createChapter: ICreateChapter): Promise<IChapter> => {
    const accessToken = await authService.getAccessToken()

    var bodyFormData = new FormData()
    bodyFormData.append("name", createChapter.name)
    bodyFormData.append("description", createChapter.description)
    bodyFormData.append("trainingModuleId", createChapter.trainingModuleId)
    bodyFormData.append("imageFile", createChapter.imageFile)
    bodyFormData.append("id", createChapter.id)

    const { data } = await axios({
      method: "post",
      baseURL: config.apiUrl,
      url: "/chapter",
      data: bodyFormData,
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${accessToken}`,
      },
    })

    return data
  }

  public getChapters = async (): Promise<Array<IChapter>> => {
    const accessToken = await authService.getAccessToken()

    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    const { data } = await this.http.get<Array<IChapter>>("/chapter", config)

    return data
  }

  public getChapter = async (id: string): Promise<IChapter> => {
    const accessToken = await authService.getAccessToken()

    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    const { data } = await this.http.get<IChapter>(`/chapter/${id}`, config)

    return data
  }

  public getTrainingModuleChapters = async (appId: string): Promise<Array<IChapter>> => {
    const accessToken = await authService.getAccessToken()

    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    const { data } = await this.http.get<Array<IChapter>>(
      `/trainingmodule/${appId}/chapter`,
      config,
    )

    return data
  }

  public updateChapter = async (
    chapterId: string,
    updateChapter: IUpdateChapter,
  ): Promise<IChapter> => {
    const accessToken = await authService.getAccessToken()

    var bodyFormData = new FormData()
    bodyFormData.append("name", updateChapter.name)
    bodyFormData.append("description", updateChapter.description)
    bodyFormData.append("trainingModuleId", updateChapter.trainingModuleId)

    if (updateChapter.imageFile !== undefined) {
      bodyFormData.append("imageFile", updateChapter.imageFile)
    }

    const { data } = await axios({
      method: "put",
      baseURL: config.apiUrl,
      url: `/chapter/${chapterId}`,
      data: bodyFormData,
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${accessToken}`,
      },
    })

    return data
  }

  public deleteChapter = async (chapterId: string) => {
    const accessToken = await authService.getAccessToken()

    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    const resp = await this.http.delete(`/chapter/${chapterId}`, config)

    return resp
  }
}

const chapterService = new ChapterService()

export default chapterService
